import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ValgtInstallationService } from "@e-forsyning/common/valgt-installation";

import { EjeroplysningerViewModel } from "./model/ejeroplysninger.view-model";

@Injectable({ providedIn: "root" })
export class EjeroplysningerSandbox {
    constructor(private readonly valgtInstallationService: ValgtInstallationService) {}

    public hentViewModel(): Observable<EjeroplysningerViewModel> {
        const installationsoplysninger$ = this.valgtInstallationService.hentInstallationsoplysninger();
        return installationsoplysninger$.pipe(map((i) => ({ navn: i.ejerNavn })));
    }
}
